'use client';

import dynamic from 'next/dynamic';

export const ScrapingTemplateLibrary = dynamic(() => import('.'));
